export default __webpack_public_path__ + "static/media/close.120298e1.png";